import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import ApiClient from "#/redux/api/ApiClient";
import { getErrorMessage } from "#/utils/APIUtils";

const baseUrl = "/api/dog/testna_postaja/postaje";

export const fetchTestStationsPage = createAsyncThunk(
  "testStation/page",
  async ({ page, filter, sort }, { rejectWithValue, fulfillWithValue }) => {
    try {
      const response = await ApiClient.get(
        `${baseUrl}/page`,
        null,
        page,
        filter,
        sort
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

const testStationSlice = createSlice({
  name: "testStation",
  initialState: {
    page: {},
    isLoading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTestStationsPage.fulfilled, (state, action) => {
        state.isLoading = false;
        state.page = action.payload;
      })
      .addCase(fetchTestStationsPage.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(fetchTestStationsPage.pending, (state, _) => {
        state.isLoading = true;
        state.error = null;
      });
  },
});

export default testStationSlice.reducer;
